import React from "react";
import { connect } from "react-redux";
import SelectList from "./component";
import { getPickupBlock } from "api/pickupBlocks";
import {
  setFormData,
  nextStep,
  previousStep,
  pickupBlocksApi,
} from "../pickup-form.actions";
import { reduxForm, change, formValueSelector } from "redux-form";
// import validate from '../pickupBlocks-search-by-donor-location/validate';
import PickupFormComponent from "../pickupBlocks-search-by-donor-location/component";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";
import { getPickupBlockByType } from "utils/helpers";

const thisForm = "publicPickupForm";
const selectForm = formValueSelector(thisForm);

const requestPickupBlocks = (form) => {
  return (dispatch, getState) => {
    // Stores the form data locally to the store.
    dispatch(setFormData(form));

    let state = getState();

    // Makes the actual API request who's promise is used for validation in redux-form
    dispatch(
      pickupBlocksApi.get(
        {
          zipCode: form.zipCode,
          hasFurniture: state.donorWizard.formValues.hasFurniture,
          availableStops: true,
          futureEvents: true,
          enabled: true,
        },
        true
      )
    );
  };
};

const submitPickupBlock = (id) => {
  return (dispatch, getState) => {
    let state = getState();

    getPickupBlock(id)
      .then((pickupBlock) => {
        const pickupStillValid = pickupBlock.data.data[0].stopsAvailable > 0;
        if (pickupStillValid) {
          dispatch(setFormData({ pickupBlock: pickupBlock.data.data[0] }));
          dispatch(nextStep());
        } else {
          //TODO: Make this more pleasant
          Tracking.track("Step 3: Logged: Pickup Block Expired");
          alert(
            `We're sorry, the pickup time you requested is no longer available, please choose again`
          );
          let zipCode =
            state.donorWizard.formValues.zipCode ||
            state.donorWizard.formValues.location.zip;
          dispatch(
            requestPickupBlocks({
              zipCode: zipCode,
              hasFurniture: state.donorWizard.formValues.hasFurniture,
            })
          );
        }
      })
      .catch((err) => {
        showToastError();
      });
  };
};

const mapStateToProps = (state, ownProps) => {
  const { pickupBlocks } = state.donorWizard;
  const { pickupTypes } = state.pickupTypes;

  const pickupTypesAvailable = [];

  pickupTypes.map((item) => {
    if (getPickupBlockByType(pickupBlocks, item).length > 0) {
      pickupTypesAvailable.push(item);
    }
  });

  const pickupTypesId = selectForm(state, "pickupTypesId");
  const pickupTypeIdDefault = pickupTypesAvailable[0];

  return {
    pickupBlocks: state.donorWizard.pickupBlocks,
    pickupBlockId: selectForm(state, "pickupBlockId"),
    pickupTypesId: pickupTypesId
      ? pickupTypesId
      : pickupTypeIdDefault.id.toString(),
    pickupType: pickupTypesId
      ? pickupTypes.find(
          (pickupType) => pickupType.id === Number.parseInt(pickupTypesId)
        )
      : pickupTypeIdDefault,
    pickupTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    previousStep: () => dispatch(previousStep()),
    onSubmit: (form) => {
      Tracking.track("Step 3: Logged: Pickup Block Chosen");
      window.scrollTo(0, 0);
      dispatch(submitPickupBlock(form.pickupBlockId));
    },
    onSelect: (id) => {
      dispatch(change(thisForm, "pickupBlockId", id));
      window.scrollTo(0, 9999);
    },
  };
};

// Connect to the store using a container component
// Create a component which injects redux form state, also handles handleSubmit of the underlying form component
const withForm = reduxForm({ form: thisForm, destroyOnUnmount: false })(
  SelectList
);

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(withForm);

// Export Complete wrapper component ( Inject Reducer -> Connect -> Redux-Form -> Component )
export default withConnect;
